<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form inline size="small">
        <el-form-item label="关键词">
          <el-input
            v-model="listQuery.keyword"
            placeholder="酒店ID/编码/礼品ID/礼品名称"
            clearable
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item label="礼品ID">
          <el-input
            v-model="listQuery.gift_id"
            placeholder="精确查询"
            clearable
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item label="礼品名称">
          <el-input
            v-model="listQuery.gift_name"
            placeholder="精确查询"
            clearable
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 360px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      stripe
      size="small"
    >
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="API账号ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.api_account_id }}
        </template>
      </el-table-column>

      <el-table-column label="价格方案ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.price_plan_id }}
        </template>
      </el-table-column>

      <el-table-column label="丽呈酒店ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_id }}
        </template>
      </el-table-column>

      <el-table-column label="酒店编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_code }}
        </template>
      </el-table-column>

      <el-table-column label="礼品ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.gift_id }}
        </template>
      </el-table-column>

      <el-table-column label="礼品名称" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.gift_name }}
        </template>
      </el-table-column>

      <el-table-column label="单位" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.unit === '1'" type="info" size="mini">份</el-tag>
          <el-tag v-else-if="scope.row.unit === '2'" type="info" size="mini">份/天</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="预约类型" min-width="120" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.appoint_type === 0" type="info" size="mini">无需预约</el-tag>
          <el-tag v-else-if="scope.row.appoint_type === 1" type="warning" size="mini">需提前预约</el-tag>
          <el-tag v-else-if="scope.row.appoint_type === 2" type="warning" size="mini">提前N天预约</el-tag>
          <el-tag v-else-if="scope.row.appoint_type === 3" type="warning" size="mini">提前N小时预约</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="售价" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.sale_price !== null ? '¥' + scope.row.sale_price : '-' }}
        </template>
      </el-table-column>

      <el-table-column label="同步时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.sync_at }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>

      <el-table-column label="其他" min-width="80" align="center">
        <template slot-scope="scope">
          <span v-if="hasExtraData(scope.row)">...</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleViewDetail(scope.row)"
          >
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 查看详情弹窗 -->
    <el-dialog
      title="礼品详情"
      :visible.sync="dialogDetailVisible"
      width="800px"
      :close-on-click-modal="true"
    >
      <div class="detail-content">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="丽呈酒店ID">
            {{ currentRow.hotel_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="酒店编码">
            {{ currentRow.hotel_code || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="礼品ID">
            {{ currentRow.gift_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="礼品名称">
            {{ currentRow.gift_name || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="数量">
            {{ currentRow.num || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="单位">
            <el-tag v-if="currentRow.unit === '1'" type="info" size="mini">份</el-tag>
            <el-tag v-else-if="currentRow.unit === '2'" type="info" size="mini">份/天</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="预约类型">
            <el-tag v-if="currentRow.appoint_type === 0" type="info" size="mini">无需预约</el-tag>
            <el-tag v-else-if="currentRow.appoint_type === 1" type="warning" size="mini">需提前预约</el-tag>
            <el-tag v-else-if="currentRow.appoint_type === 2" type="warning" size="mini">提前N天预约</el-tag>
            <el-tag v-else-if="currentRow.appoint_type === 3" type="warning" size="mini">提前N小时预约</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="预约值">
            {{ currentRow.appoint_value || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="预约电话">
            {{ currentRow.booking_phones || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="售价">
            {{ currentRow.sale_price !== null ? '¥' + currentRow.sale_price : '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="成人最大人数">
            {{ currentRow.max_adult_number !== null ? currentRow.max_adult_number + '人' : '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="儿童最大人数">
            {{ currentRow.max_child_number !== null ? currentRow.max_child_number + '人' : '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="接待次数">
            {{ currentRow.reception_times || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="票券获取方式">
            <el-tag v-if="currentRow.ticket_access_type === 0" type="info" size="mini">无需获取</el-tag>
            <el-tag v-else-if="currentRow.ticket_access_type === 1" type="warning" size="mini">需要获取</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="票券获取说明">
            {{ currentRow.ticket_access_desc || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="票券使用地点">
            <el-tag v-if="currentRow.ticket_use_site === 1" type="success" size="mini">仅酒店可用</el-tag>
            <el-tag v-else-if="currentRow.ticket_use_site === 2" type="warning" size="mini">其他地点</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="票券使用地点说明">
            {{ currentRow.ticket_use_site_desc || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="票券有效期">
            <el-tag v-if="currentRow.ticket_valid === 1" type="info" size="mini">入住期间有效</el-tag>
            <el-tag v-else-if="currentRow.ticket_valid === 2" type="info" size="mini">入住首日有效</el-tag>
            <el-tag v-else-if="currentRow.ticket_valid === 3" type="info" size="mini">产品有效期内均有效</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="不可用日期" :span="2">
            {{ currentRow.unable_use_index || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="不可用日期说明" :span="2">
            {{ currentRow.unable_use_other_desc || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="自由使用说明" :span="2">
            {{ currentRow.free_style_desc || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="图片URL列表" :span="2">
            {{ currentRow.image_url_list || '无' }}
          </el-descriptions-item>
        </el-descriptions>

        <div class="raw-json-section">
          <div class="raw-json-label">原始JSON：</div>
          <div v-if="currentRawJson" class="raw-json-content">
            <pre>{{ currentRawJson }}</pre>
          </div>
          <div v-else class="raw-json-empty">无原始数据</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      // 搜索参数
      listQuery: {
        page: 1,
        limit: 10,
        keyword: undefined,
        gift_id: undefined,
        gift_name: undefined,
        start_at: undefined,
        end_at: undefined,
        sort: 'id',
        order: 'DESC',
      },
      // 日期范围
      dateRange: null,
      // 查看详情弹窗
      dialogDetailVisible: false,
      currentRow: {},
      currentRawJson: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 判断是否有额外数据
    hasExtraData(row) {
      return row.num || row.appoint_value || row.booking_phones ||
        row.free_style_desc || row.image_url_list || row.max_adult_number ||
        row.max_child_number || row.reception_times || row.ticket_access_desc ||
        row.ticket_use_site_desc || row.unable_use_index || row.unable_use_other_desc ||
        row.raw_json
    },
    // 获取列表数据
    getList() {
      this.listLoading = true
      // 处理日期范围
      if (this.dateRange && this.dateRange.length === 2) {
        this.listQuery.start_at = this.dateRange[0]
        this.listQuery.end_at = this.dateRange[1]
      } else {
        this.listQuery.start_at = undefined
        this.listQuery.end_at = undefined
      }

      // 处理空值参数
      const params = {}
      Object.keys(this.listQuery).forEach((key) => {
        const val = this.listQuery[key]
        if (val !== '' && val !== undefined && val !== null) {
          params[key] = val
        }
      })

      request({
        url: '/api/backend/liCheng/hotel/giftList',
        method: 'get',
        params: params,
      })
        .then((response) => {
          this.list = response.data.items
          this.total = response.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 点击查询按钮
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    // 点击重置按钮
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        keyword: undefined,
        gift_id: undefined,
        gift_name: undefined,
        start_at: undefined,
        end_at: undefined,
        sort: 'id',
        order: 'DESC',
      }
      this.dateRange = null
      this.getList()
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    // 当前页码变化
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    // 查看详情
    handleViewDetail(row) {
      this.currentRow = Object.assign({}, row)
      if (row.raw_json) {
        try {
          const parsed = JSON.parse(row.raw_json)
          this.currentRawJson = JSON.stringify(parsed, null, 2)
        } catch (e) {
          this.currentRawJson = row.raw_json
        }
      } else {
        this.currentRawJson = ''
      }
      this.dialogDetailVisible = true
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  margin-bottom: 10px;
}
.pagination-container {
  margin-top: 20px;
}
.detail-content {
  max-height: 500px;
  overflow: auto;
}
.raw-json-section {
  margin-top: 15px;
  .raw-json-label {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .raw-json-content {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    max-height: 200px;
    overflow: auto;
    pre {
      margin: 0;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-size: 12px;
      line-height: 1.5;
      color: #333;
    }
  }
  .raw-json-empty {
    text-align: center;
    padding: 20px;
    color: #999;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
}
</style>
